import React from "react"
import styled from "styled-components"
import NextImg from "@/common/components/NextImg/index"
import { theme } from "@/common/Mixin"
import { useTranslation } from "next-i18next"

interface ShowCaseSolutionProps {
  data: {
    QA: any[]
  }
  themeNew: any
}

export default function Solution({ data, themeNew }: ShowCaseSolutionProps) {
  const { t } = useTranslation(["useCaseCommon"])
  return (
    <Wrapper themeNew={themeNew}>
      <TitlesWrapper>
        <QAsWrapper>
          <LableWrapper>
            <QWrapper>
              <h3>{t("case.solution.q")}</h3>
            </QWrapper>
            <LableAWrapper>
              <h3>{t("case.solution.a")}</h3>
            </LableAWrapper>
          </LableWrapper>
          {data.QA.map(({ q, a, img }, index) => (
            <QAWrapper
              key={index}
              themeNew={themeNew}
              className={index === 0 ? "first" : ""}
            >
              <QWrapper themeNew={themeNew}>
                <h4>{q}</h4>
              </QWrapper>
              <AWrapper themeNew={themeNew}>
                <h4>{a}</h4>
                <ImageWrapper>
                  <NextImg src={img} />
                </ImageWrapper>
              </AWrapper>
            </QAWrapper>
          ))}
        </QAsWrapper>
      </TitlesWrapper>
    </Wrapper>
  )
}

interface ThemeNewProps {
  themeNew?: any
}

const Wrapper = styled.div<ThemeNewProps>`
  width: 100%;
  border-radius: var(--BORA);
  padding: var(--cardPadding);
  background: linear-gradient(
    90deg,
    ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)}33,
    ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)}10
  );
`
const TitlesWrapper = styled.div`
  @media (${theme.md}) {
    h2 {
      font-size: var(--h3);
    }
  }
`
const QAsWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
`
const QAWrapper = styled.div<ThemeNewProps>`
  display: grid;
  grid-template-columns: 1fr minmax(500px, 1fr);
  justify-items: start;
  align-items: center;
  border-top: 1px solid
    ${({ themeNew }) => (themeNew ? themeNew.primary : theme.color.primary)};
  padding: 32px 16px;
  gap: var(--cardGap);
  @media (${theme.lg}) {
    grid-template-columns: 1fr;
    gap: var(--textGap);
    &.first {
      border-top: none;
    }
  }
`
const QWrapper = styled.h4<ThemeNewProps>`
  text-align: left;
  text-align: center;
  justify-self: center;
  padding: 12px var(--cardPadding);
  @media (${theme.xl}) {
    padding: 0;
    justify-self: start;
    text-align: left;
  }
  @media (${theme.md}) {
    h4 {
      font-size: var(--p);
    }
  }
  h4 {
    ::before {
      content: "Pain: ";
      color: ${({ themeNew }) =>
        themeNew ? themeNew.secondary : theme.color.primary};
      display: none;
      @media (${theme.md}) {
        display: block;
        width: 100%;
      }
    }
  }
`
const AWrapper = styled.h4<ThemeNewProps>`
  width: 100%;
  text-align: left;
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--textGap);
  color: ${theme.color.white};
  @media (${theme.md}) {
    h4 {
      font-size: var(--p);
    }
  }
  h4 {
    ::before {
      display: none;
      content: "Solution: ";
      color: ${({ themeNew }) =>
        themeNew ? themeNew.primary : theme.color.primary};
      @media (${theme.md}) {
        display: block;
        width: 100%;
      }
    }
  }
`
const ImageWrapper = styled.div`
  position: relative;
  img {
  }
`
const LableWrapper = styled(QAWrapper)`
  border: none;
  justify-items: center;
  min-height: 10px;
  padding: 16px;
  @media (${theme.lg}) {
    display: none;
  }
`

const LableAWrapper = styled(AWrapper)`
  text-align: center;
`
